module.exports = __webpack_public_path__ + "media/images/pic/brodno/people/marika-4ce548e0eb4f831a1ff4dceef11414c2.png";